import { frontendURL } from '../../../../helper/URLHelper';

// O hub settings/captain MUDOU pra area do brain (captain/brain/config).
// Nome preservado (padrao da faxina): links e pushes antigos aterrissam la.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/captain'),
      name: 'captain_settings_index',
      redirect: to => ({
        name: 'brain_config',
        params: { accountId: to.params.accountId },
      }),
    },
  ],
};
